export enum StateExtensionAction {
  update,
  create,
  remove,
}
